import { BarChart, barElementClasses  } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';

const BarChartData = (props) => {
    // console.log("props in barchart", props);
    const { dataset } = props.data;
    const { tickPlacement, labelYAxis, labelXAxis, height, width, yAxisDataKey, xAxisDataKey, chartLabel, colors } = props.data.options;
    // console.log("dataset in barchart", tickPlacement, labelYAxis, labelXAxis, height, width, yAxisDataKey, xAxisDataKey, chartLabel, colors);
    
    const valueFormatter = (value) => {
        return value;
    };

    const chartSetting = {
        yAxis: [
            {
                label: labelYAxis || "",
                width: width
            }
        ],
        series: [{ dataKey: yAxisDataKey, label: chartLabel, valueFormatter }],
        height: height,
        margin: { left: 0 },
        hideLegend: true
    };

    return (
        <BarChart
            sx = {
                (theme) => ({
                        [`.${axisClasses.root}`]: {
                            [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                            stroke:  '#98a2b3',
                        },
                        [`.${axisClasses.tickLabel}`]: {
                            fill: '#98a2b3',
                        }
                    },
                })
            }
            dataset={dataset}
            xAxis={
                [{ 
                    dataKey: xAxisDataKey, tickPlacement : tickPlacement, 
                    colorMap: {
                        type: 'piecewise',
                        thresholds: [],
                        colors: colors,
                        
                        
                        //                 valueFormatter: (month, context) =>
                            // context.location === 'tick'
                        //   ? `${month.slice(0, 3)} \n2023`
                        //   : `${month} 2023`
                    }, 
                    valueFormatter: (value, context) => 
                        value = value.split(" ").join("\n"),
                    
                }]}
            {...chartSetting}
      />
    )
}

// sx = {
//     (theme) => ({
//         [`.${barElementClasses.root}`]: {
//             fill: (theme.vars || theme).palette.background.paper,
//             strokeWidth: 2,
//         },
//         [`.MuiBarElement-series-l_id`]: {
//             stroke: colors[0],
//         },
//         [`.MuiBarElement-series-r_id`]: {
//             stroke: colors[1],
//         },
//         [`.${axisClasses.root}`]: {
//             [`.${axisClasses.tick}, .${axisClasses.line}`]: {
//                 stroke: '#006BD6',
//                 strokeWidth: 3,
//             },
//             [`.${axisClasses.tickLabel}`]: {
//                 fill: '#006BD6',
//             },
//         },
//         border: '1px solid black',
//         backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 0, 0, 0.1) 1px, transparent 1px)',
//         backgroundSize: '35px 35px',
//         backgroundPosition: '20px 20px, 20px 20px',
//         ...theme.applyStyles('dark', {
//             borderColor: 'rgba(255,255,255, 0.1)',
//             backgroundImage: 'linear-gradient(rgba(255,255,255, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255, 0.1) 1px, transparent 1px)',
//         }),
//     })
// }

export default BarChartData;